<script>
  export default{
    name: 'select-tipo-bem-option',
    props: ['tipo'],
    data () {
      return {}
    },
    computed: {},
    mounted () {
    },
    destroyed () {
    },
    methods: {
      criaElementos (e, values) {
        let elements = []
        for (let i = 0; i < values.length; i++) {
          elements.push(this.recursiveCreateElements(e, values[i]))
        }
        return elements
      },
      criaElementoComum (e, tipo) {
        return e(
          'option',   // tag name
          {
            attrs: {
              value: tipo.id
            },
            domProps: {
              innerHTML: tipo.nome
            }
          }
        )
      },
      criaElementoPai (e, tipo) {
        return e(
          'optgroup',   // tag name
          {
            attrs: {
              label: tipo.nome
            }
          },
          this.criaElementos(e, tipo.filhos)
        )
      },
      recursiveCreateElements (e, tipo) {
        if (tipo.filhos !== null) {
          return this.criaElementoPai(e, tipo)
        }
        return this.criaElementoComum(e, tipo)
      }
    },
    components: {},
    render: function (createElement) {
      return this.recursiveCreateElements(createElement, this.tipo)
    }
  }
</script>



// WEBPACK FOOTER //
// SelectTipoBemRenderOption.vue?1576dcdb